module.exports = __webpack_public_path__ + "img/icon_img_12.b8099565.png";